import { Button } from 'antd'
import React from 'react'
import styled from 'styled-components/macro'
import {
  CATCH_BOARD_OWNER_FILTER,
  CATCH_BOARD_READINESS_FILTER,
} from './catchBoardConstants'
import { getCatchBoardEmptyCopy } from 'src/utils/catchBoardEmptyCopy'

/**
 * Board-level empty copy — filters vs a truly empty pipeline.
 */
const CatchBoardEmptyState = ({
  search = '',
  hideClosed = false,
  ownerFilter = CATCH_BOARD_OWNER_FILTER.MINE,
  readinessFilter = CATCH_BOARD_READINESS_FILTER.ALL,
  onCreateDeal,
  onShowAllDeals,
}) => {
  const copy = getCatchBoardEmptyCopy({
    search,
    hideClosed,
    ownerFilter,
    readinessFilter,
  })

  return (
    <Banner data-testid='catch-board-empty'>
      <EmptyTitle>{copy.title}</EmptyTitle>
      <EmptyHint>{copy.hint}</EmptyHint>
      <EmptyActions>
        <Button
          type='primary'
          onClick={onCreateDeal}
          data-testid='catch-board-empty-new-deal'
        >
          New deal
        </Button>
        {copy.showAllDeals ? (
          <Button
            onClick={onShowAllDeals}
            data-testid='catch-board-empty-all-deals'
          >
            All deals
          </Button>
        ) : null}
      </EmptyActions>
    </Banner>
  )
}

const Banner = styled.div`
  padding: 16px 18px;
  border: 1px dashed rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.7);
`

const EmptyTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colours.broccoliGreen || '#1a1a1a'};
`

const EmptyHint = styled.p`
  margin: 6px 0 12px;
  font-size: 13px;
  line-height: 1.45;
  color: ${({ theme }) => theme.colours.stormGrey || '#666'};
`

const EmptyActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export default CatchBoardEmptyState
